// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__25fJf","buttons":"RemoveExpirationActionButtons_buttons__I_S0j"};